/* tslint:disable */

declare var Object: any;
export interface JobOrderJobBoardAssociationInterface {
  "sfdcId"?: string;
  "ts2__JobBoardSetup__c"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "ts2__JobOrder__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobOrderJobBoardAssociation implements JobOrderJobBoardAssociationInterface {
  "sfdcId": string;
  "ts2__JobBoardSetup__c": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "ts2__JobOrder__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobOrderJobBoardAssociationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobOrderJobBoardAssociation`.
   */
  public static getModelName() {
    return "JobOrderJobBoardAssociation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobOrderJobBoardAssociation for dynamic purposes.
  **/
  public static factory(data: JobOrderJobBoardAssociationInterface): JobOrderJobBoardAssociation{
    return new JobOrderJobBoardAssociation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobOrderJobBoardAssociation',
      plural: 'JobOrderJobBoardAssociations',
      path: 'JobOrderJobBoardAssociations',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__JobBoardSetup__c": {
          name: 'ts2__JobBoardSetup__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "ts2__JobOrder__c": {
          name: 'ts2__JobOrder__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
